<template>
  <div class="wombat-row" :style="styles" @click='rowClicked'>
    <div
      class="cell column"
      v-for="column in preparedColumns"
      :key="column.name"
      :class="[column.class, column._className]"
    >
      <slot name="row-cell" :column="column" :item="item">
        <wombat-row-default-cell :column="column" :item="item" />
      </slot>
    </div>
  </div>
</template>

<script>
import WombatRowDefaultCell from './WombatRowDefaultCell.vue';

export default {
  name: 'WombatRow',
  components: {
    WombatRowDefaultCell,
  },
  props: {
    height: {
      type: Number,
    },
    item: {
      type: Object,
    },
    columns: {
      type: Array,
      required: true,
    },
    clickable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    rowClicked() {
      if (this.clickable) {
        this.$emit('rowClicked', this.item);
      }
    },
  },
  computed: {
    styles() {
      const styles = {};

      if (this.height) {
        styles.height = `${this.height}px`;
        styles.lineHeight = `${this.height}px`;
      }

      return styles;
    },
    preparedColumns() {
      const columns = this.columns.map((item, index) => {
        const style = {};

        if (item.width) {
          style.width = item.width;
        } else {
          style.flex = 1;
        }

        const machineName = (item.name || `column${index}`).toLowerCase().replace(/\W/g, '');

        return {
          ...item,
          style,
          _className: `column-${machineName}`,
        };
      });
      return columns;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.wombat-row {
  width: 100%;
  display: flex;
  flex-direction: row;

  .row-cell {
    height: 100%;
  }

  .date {
    color: var(--text-secondary);
  }
}
</style>
